import React from "react";
import EditNavbar from "../EditNavbar";
import KeyDropdownValue from "../KeyDropdownValue";
import InputKeyValue from "../InputKeyValue";
import { t } from "../../../../i18n";
import CustomButton from "../CustomButton";
import { SearchIcon } from "../../normalizer";

const NewAddressForm = (props) => {
  const {
    country,
    availableCountries,
    state,
    availableStates,
    className,
    cancelMargin,
    errors = {},
    isVirtual: isVirtualProp = false,
    // When true, renders a "Virtual" switch letting the user pick the
    // address type themselves (used on the profile page). When false
    // (default, used by the cart flow) the address type is fully driven
    // by the `isVirtual` prop and no switch is shown.
    allowVirtualToggle = false,
    ...actions
  } = props;

  const [isValid, setIsValid] = React.useState(false);
  const [virtualToggle, setVirtualToggle] = React.useState(isVirtualProp);
  const isVirtual = allowVirtualToggle ? virtualToggle : isVirtualProp;

  const validate = (data) => {
    let errors = {
      address1: undefined,
      zipCode: undefined,
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      phone: undefined,
      addressName: undefined,
    };

    if (!data) {
      setIsValid(false);
      errors = isVirtual
        ? {
            firstName: "Por favor preencha o primeiro nome",
            lastName: "Por favor preencha o apelido",
            email: "Por favor preencha o email",
            phone: "Por favor preencha o telemóvel",
            addressName: "Por favor preencha o nome da morada",
          }
        : {
            address1: "Por favor preencha o endereço",
            zipCode: "Por favor preencha o código postal",
            firstName: "Por favor preencha o primeiro nome",
            lastName: "Por favor preencha o apelido",
            email: "Por favor preencha o email",
            phone: "Por favor preencha o telemóvel",
            addressName: "Por favor preencha o nome da morada",
          };
      return;
    }

    // Physical location fields are not collected (or required) for virtual
    // deliveries — hidden in the UI below, so skip their validation too.
    if (!isVirtual && !data.address1) {
      errors.address1 = "Por favor preencha o endereço";
    }
    if (!isVirtual && !data.zipCode) {
      errors.zipCode = "Por favor preencha o código postal";
    }
    if (!data.firstName) {
      errors.firstName = "Por favor preencha o primeiro nome";
    }
    if (!data.lastName) {
      errors.lastName = "Por favor preencha o apelido";
    }
    if (!data.email) {
      errors.email = "Por favor preencha o email";
    }
    if (!data.phone) {
      errors.phone = "Por favor preencha o telemóvel";
    }
    if (!data.name) {
      errors.name = "Por favor preencha o nome da morada";
    }
    if (Object.keys(errors).some(key => errors[key] !== undefined)) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }

  };

  const handleChange = (e) => {
    e.preventDefault();
    const {
      addressName,
      address1,
      city,
      zipCode,
      firstName,
      lastName,
      email,
      phone,
      coutry,
      state,
    } = e.currentTarget;
    validate({
      name: addressName.value,
      address1: isVirtual ? undefined : address1 && address1.value,
      city: isVirtual ? undefined : city && city.value,
      zipCode: isVirtual ? undefined : zipCode && zipCode.value,
      firstName: firstName.value,
      lastName: lastName.value,
      email: email.value,
      phone: phone.value,
      country: isVirtual ? undefined : country && country.value,
      state: isVirtual ? undefined : state && state.value,
    });
  };
  const handleOnSubmit = (event) => {
    event.preventDefault();
    const {
      address1,
      city,
      address2,
      zipCode,
      addressName,
      firstName,
      lastName,
      email,
      phone,
    } = event.target;
    const payload = {
      address1: isVirtual ? undefined : address1 && address1.value,
      city: isVirtual ? undefined : ((city && city.value) || "Casal do Carido"),
      address2: isVirtual ? undefined : address2 && address2.value,
      zipCode: isVirtual ? undefined : zipCode && zipCode.value,
      addressName: addressName.value,
      firstName: firstName.value,
      lastName: lastName.value,
      email: email.value,
      phone: phone.value,
      country: isVirtual ? undefined : (country && country.value),
      state: isVirtual ? undefined : (state && state.value),
    }
    
    if (isVirtual) {
      payload.is_virtual = true;
    }
    actions.onNewAddress(payload);
  };

  return (
    <form
      id="user-address-form"
      onChange={handleChange}
      className="user-address-form"
      onSubmit={handleOnSubmit}
    >
      <div className="user-address-form-header">
        <div className="user-address-form-header-text">
          <h5 className="user-address-form-name">Adicionar dados de envio</h5>
          <div className="user-address-form-msg">
            Edite os campos abaixo e guarde as alterações
          </div>
        </div>
        {allowVirtualToggle && (
          <label className="user-address-form-toggle">
            <input
              type="checkbox"
              className="user-address-form-toggle-input"
              checked={virtualToggle}
              onChange={(e) => setVirtualToggle(e.target.checked)}
            />
            <span
              className={
                "user-address-form-toggle-track" +
                (virtualToggle ? " user-address-form-toggle-track--active" : "")
              }
            />
            <span className="user-address-form-toggle-label">
              {t("gamification2026.profile.virtual-address-toggle")}
            </span>
          </label>
        )}
      </div>
      <div className="user-address-form-container">
        {/* Row 1 — Nome da morada 12/12 */}
        <div className="user-address-form-row">
          <div className="user-address-form-column4">
            <InputKeyValue
              title="Título"
              name="addressName"
              placeholder="Escritório"
              error={errors.addressName}
            />
          </div>
        </div>

        {/* Row 2 — Primeiro nome 6/12 | Apelido 6/12 */}
        <div className="user-address-form-row">
          <div className="user-address-form-column2">
            <InputKeyValue
              title="Primeiro nome"
              name="firstName"
              placeholder="Insira primeiro nome"
              error={errors.firstName}
            />
          </div>
          <div className="user-address-form-column2">
            <InputKeyValue
              title="Apelido"
              name="lastName"
              placeholder="Inserir apelido"
              error={errors.lastName}
            />
          </div>
        </div>

        {/* Row 3 — Email 6/12 | Telemóvel 6/12 */}
        <div className="user-address-form-row">
          <div className="user-address-form-column2">
            <InputKeyValue
              title="Email"
              name="email"
              placeholder="exemplo@mail.com"
              error={errors.email}
            />
          </div>
          <div className="user-address-form-column2">
            <InputKeyValue
              title="Telemóvel"
              name="phone"
              placeholder="912345678"
              error={errors.phone}
            />
          </div>
        </div>

        {!isVirtual && (
          <>
            {/* Row 4 — Endereço 6/12 | Código Postal 3/12 | Cidade 3/12 */}
            <div className="user-address-form-row">
              <div className="user-address-form-column2">
                <InputKeyValue
                  leftIcon={<SearchIcon />}
                  title="Endereço"
                  name="address1"
                  placeholder="Rua das Flores, 123"
                  error={errors.address1}
                />
              </div>
              <div className="user-address-form-column">
                <InputKeyValue
                  leftIcon={<SearchIcon />}
                  title="Código Postal"
                  name="zipCode"
                  placeholder="0000-000"
                  error={errors.zipCode}
                />
              </div>
              <div className="user-address-form-column">
                <InputKeyValue
                  title="Localidade"
                  placeholder="Lisboa"
                  name="city"
                />
              </div>
            </div>

            {/* Row 5 — Endereço 2 6/12 | País 3/12 | Região 3/12 */}
            <div className="user-address-form-row">
              <div className="user-address-form-column2">
                <InputKeyValue
                  title="Restante morada"
                  name="address2"
                  placeholder="2º Esq., Bloco B"
                  error={errors.address2}
                />
              </div>
              <div className="user-address-form-column">
                <KeyDropdownValue
                  title="País"
                  name="country"
                  selectedValue={country}
                  options={availableCountries}
                  onChange={actions.onCountryChange}
                  optionsId="id"
                  optionsLabel="name"
                  placeholder="Portugal"
                  error={errors.country}
                  getOptionLabel={(option) => option.name}
                />
              </div>
              <div className="user-address-form-column">
                <KeyDropdownValue
                  title="Região"
                  name="state"
                  selectedValue={state}
                  optionsId="id"
                  optionsLabel="name"
                  error={errors.state}
                  options={availableStates}
                  onChange={actions.onStateChange}
                  placeholder="Continente"
                  getOptionLabel={(option) => option.name}
                />
              </div>
            </div>
          </>
        )}
      </div>
      <div className="user-address-form-actions">
        <CustomButton secondary onClick={actions.onAddressCreationCancel}>
          {t("gamification2026.profile.cancel")}
        </CustomButton>
        <CustomButton
          type={"submit"}
          disabled={!isValid}
          form="user-address-form"
        >
          {t("gamification2026.profile.save")}
        </CustomButton>
      </div>
    </form>
  );
};
export default NewAddressForm;
